import { CalendarCheck } from "lucide-react";
import { Card, CardHeader, CardContent, CardTitle } from "./ui/card";

const CertificatesStub = () => {
  return (
    <Card className="w-[calc(100vw-1.5rem)] overflow-hidden border-none shadow-none md:w-[calc(100vw-250px-1.5rem)] lg:w-[47rem]">
      <CardHeader className="px-0 py-0 pt-4">
        <div className="flex flex-col">
          <div className="group mx-auto flex flex-col items-center gap-3">
            <div className="rounded-full bg-primary/10 p-6">
              <CalendarCheck className="h-12 w-12 text-primary/80" />
            </div>
            <CardTitle className="text-lg font-medium text-gray-800 transition-colors group-hover:text-primary">
              Справки ещё не добавлены
            </CardTitle>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4 py-4">
        <div className="space-y-1 text-center">
          <div className="pb-2 text-sm text-muted-foreground">
            <p className="mx-auto max-w-[300px]">
              Передайте справки администратору — мы добавим их в личный кабинет
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
export default CertificatesStub;
